import { SVGProps } from 'react';

const VenusAndMars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 20h4m-2-4v6m0-6a5 5 0 1 0 0-10 5 5 0 0 0 0 10m9-10V2h-4m4 0-5.46 5.46"
    />
  </svg>
);
export default VenusAndMars;
